/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Ovmsa_DescriptionInputs */



/**
* | output |
* | --- |
* | "Support against the Offshore Vessel Management and Self-Assessment programme." |
*
* @param {Service_Ovmsa_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_ovmsa_description = /** @type {((inputs?: Service_Ovmsa_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Ovmsa_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对照海上船舶管理与自评估项目提供支持。")
	return /** @type {LocalizedString} */ ("Support against the Offshore Vessel Management and Self-Assessment programme.")
});